// extracted by mini-css-extract-plugin
module.exports = {"newsList":"list-module--news-list--1qMsU","newsFilter":"list-module--news-filter--MDZZ2","current":"list-module--current--qOO5U","newsBody":"list-module--news-body--2twtQ"};